<template>
  <v-app id="inspire">
    <Sidebar class="d-print-none sidebar" v-if="securedPage" />
    <Header class="d-print-none" @load="loadedCenters" v-if="securedPage" />
    <v-main style="overflow: hidden">
      <message-component></message-component>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <BottomNavigation v-if="isLoggedIn" class="bottom-navigation" />
  </v-app>
</template>

<script lang="ts">
import { mapActions, mapGetters } from "vuex";
import MessageComponent from "@/components/common/MessageComponent.vue";
import layouts from "@/components/layout/";
import setupInterceptor from "./config/interceptorsConfig.js";
import { defineComponent } from "vue";
import { mapStores } from "pinia";
import { useNavigationStore } from "./store/navigation";
import BottomNavigation from "./components/layout/BottomNavigation.vue";

export default defineComponent({
  components: {
    ...layouts,
    MessageComponent,
    BottomNavigation,
  },
  props: {
    source: String,
  },
  data: () => ({
    headerLoaded: false,
    dialog: false,
  }),
  computed: {
    ...mapStores(useNavigationStore),
    ...mapGetters({ isLoggedIn: "isLoggedIn", currentUser: "currentUser" }),

    securedPage() {
      // console.log(this.$route)
      // return this.$route.name === 'Login' || !this.$route.requiresAuth;
      return this.$route.meta?.requiresAuth || this.isLoggedIn;
    },
  },
  methods: {
    ...mapActions(["appLoading"]),
    loadedCenters() {
      // console.log(centers);
      this.headerLoaded = true;
    },
  },
  created: function () {
    setupInterceptor(this.$axios, this.$store, this.$router);
    this.navigationStore.init();
  },
});
</script>

<style scoped>
.sidebar {
  display: none;
}

.bottom-navigation {
  display: flex;
}

.version {
  display: none;
}

@media (min-width: 640px) {
  .sidebar {
    display: flex;
  }

  .bottom-navigation {
    display: none;
  }

  .version {
    display: block;
  }
}

@media print {
  .v-main {
    padding: 0px 0px 0px 0px !important;
  }
}
</style>
